module.exports = {"350824001":"平川街道","350824101":"中山镇","350824102":"岩前镇","350824103":"十方镇","350824104":"中堡镇","350824105":"桃溪镇","350824106":"城厢镇","350824107":"东留镇","350824108":"武东镇","350824109":"万安镇","350824110":"永平镇","350824111":"象洞镇","350824112":"中赤镇","350824113":"湘店镇","350824114":"大禾镇","350824203":"民主乡","350824204":"下坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350824.json
// module id = 1346
// module chunks = 0